<script>
	import Steps from '../Steps';
	import { mapState,mapMutations } from 'vuex';
	import ModalDmm from '../modals/ModalDmm.vue';
	import SearchProvider from '../modals/SearchProvider.vue';
	import CompradorModal from '../modals/CompradorModal.vue';
	import {stepFourTarget} from '../../stepsTargets.js';

	export default{
		props:{
			reviewApprove: {
				type: Boolean,
				default: false
			}
		},
		components:{Steps,SearchProvider,CompradorModal,ModalDmm},
		data(){
			return{
				captureProvider: true,
				comprador:{userid:'',nombre:'',apellidos:''},
				dmm:{userid:'',nombre:'',apellidos:''},
				steps: stepFourTarget,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Terminar paso'
					}
				},
			}
		},
		computed:{
			...mapState(['stepActive','stepFour','alertas'])
		},
		mounted(){
			if(this.stepActive == 4 && this.alertas){
				this.$tours['stepFour'].start();
			}
		},
		methods:{
			...mapMutations(['changeStepActive','saveStepFour']),
			saveStep(){
				this.saveStepFour(this.stepFour);
			},
			showProvider(){
				window.$('#search-provider').modal('show');
			},
			showModalComprador(){
				window.$('#comprador-modal').modal('show');
			},
			showModalDMM(){
				window.$('#dmm-modal').modal('show');
			},
			restartTour(){
				this.$tours['stepFour'].start();
			}
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepFour" :steps="steps" :options="myOptions"/>
		<div v-if="!reviewApprove">
			<div class="header-tools">
				<div class="title">
					Crear Solicitud Acuerdo: Paso 4 (Aprobadores)
				</div>
				<div class="buttons">
					<div>
						<button @click="changeStepActive(stepActive-1);saveStep()"> <i class="fas fa-chevron-left"></i> Atrás </button>
						<button data-v-step="36" @click="changeStepActive(stepActive+1);saveStep()">Continuar <i class="fas fa-chevron-right"></i></button>
						<span class="separator-buttons">|</span>
						<button> Guardar </button>
						<button> Cancelar </button>
						| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
					</div>
				</div>
			</div>
			<steps :stepActive="stepActive"/>
			<hr class="separator-steps-content">
		</div>
		<div class="container">
			<div class="information-general">
				<div class="title">
					Aprobadores Negocio
				</div>
				<div class="info-body">
					<div class="row">
						<div class="col-md-8">
							<div class="row mb-10">
								<div class="col-md-4">Nueva Solicitud Acuerdo</div>
								<div class="col-md-4">Tipo Sol. Acuerdo: Volumen</div>
								<div class="col-md-4">Solicitud Acuerdo:</div>
							</div>
							<div class="row mb-25">
								<div class="col-md-4">Estado: Borrador Solicitud Acuerdo</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-11 table-options mt-10">
				<div class="buttons">
					<button> Export </button>
				</div>
				<table class="table-proveedor">
					<tr>
						<td>&nbsp;</td>
						<td>Nivel del Aprobadores</td>
						<td>Identificación de usuario de aprobador</td>
						<td>Nombre</td>
						<td>Apellido</td>
						<td>Estado</td>
						<td>Fecha de aprobación</td>
					</tr>
					<tr>
						<td>&nbsp;</td>
						<td class="bg-table-data">Comprador</td>
						<td data-v-step="33" @click="showModalComprador()">
							{{stepFour.comprador.userid}}
						</td>
						<td class="bg-table-data">{{stepFour.comprador.nombre}}</td>
						<td class="bg-table-data">{{stepFour.comprador.apellidos}}</td>
						<td class="bg-table-data"></td>
						<td class="bg-table-data"></td>
					</tr>
					<tr>
						<td>&nbsp;</td>
						<td class="bg-table-data">DMM</td>
						<td @click="showModalDMM()">{{stepFour.dmm.userid}}</td>
						<td class="bg-table-data">{{stepFour.dmm.nombre}}</td>
						<td class="bg-table-data">{{stepFour.dmm.apellidos}}</td>
						<td class="bg-table-data"></td>
						<td class="bg-table-data"></td>
					</tr>
				</table>
				<comprador-modal @setComprador="stepFour.comprador = $event"/>
				<modal-dmm @setDMM="stepFour.dmm = $event"/>
				<div class="subtitle-content mt-20">
					Aprobadores Proveedor
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group" data-v-step="34">
							<label for="" class="control-label">ID Proveedor Retail Link:</label>
							<input type="text" :disabled="stepFour.capturarProveedor" v-model="stepFour.idProveedorRetailLink.usuario" class="form-control paste width-100" @focus="showProvider()" value="">
						</div>
						<search-provider @setProvider="stepFour.idProveedorRetailLink = $event"/>
					</div>
					<div class="col-md-4">
						<div class="form-group" data-v-step="35">
							<div class="checkbox">
								<label>
									<input type="checkbox" name="provider" v-model="stepFour.capturarProveedor"> Proveedor no Retail Link:
								</label>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label">Nombre Contacto Proveedor:</label>
							<input v-if="stepFour.idProveedorRetailLink.nombre" v-model="stepFour.idProveedorRetailLink.nombre" placeholder="(Obligatorio si no es Retail Link)" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
							<input v-else v-model="stepFour.nombreContactoProveedor" placeholder="(Obligatorio si no es Retail Link)" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label">Correo Contacto Proveedor:</label>
							<input v-model="stepFour.correoContactoProveedor" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label">Teléfono Contacto Proveedor:</label>
							<input v-model="stepFour.telefonoContactoProveedor" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
						</div>
					</div>
				</div>
				<div class="row mb-20">
					<div class="col-md-4">
						<div class="form-group">
							<label for="" class="control-label">Fax Contacto Proveedor:</label>
							<input v-model="stepFour.faxContactoProveedor" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
						</div>
					</div>
					<div class="col-md-5">
						<div class="form-group width-225">
							<label for="" class="control-label">Identificación del Contacto del Proveedor:</label>
							<input v-model="stepFour.identificacionDelContactoDelProveedor" type="text" class="form-control" :disabled="stepFour.capturarProveedor" value="">
						</div>
					</div>
				</div>
				<div class="row">
					<div class="border-top-div col-md-10">
						<table class="table-data">
							<tr>
								<td>Creado por:</td>
								<td>ANGÉLICA SILVERIO IBANEZ</td>
								<td>Aprobador AR:</td>
								<td></td>
								<td>Cambiado por:</td>
								<td></td>
							</tr>
							<tr>
								<td>Fecha de Creación:</td>
								<td>03.04.2019</td>
								<td>Fecha de aprobación:</td>
								<td></td>
								<td>Fecha de última modificación:</td>
								<td></td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>